import { useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Head from 'next/head';
import Link from 'next/link';
import { useEffect } from 'react';

import constMeta from '@/contents/constants/constMeta';
import Button from '@/contents/General/Button';
import { Thumbnail } from '@/contents/General/Panels';
import Stack from '@/contents/General/Stack';
import Typography from '@/contents/General/Typography';
import Layout from '@/layouts';
import OptimizedImage from '@/modules/General/OptimizedImage';
import theme from '@/styles/theme';
import type { NextPageWithLayout } from '@/types';

const Container = styled(Box)`
  position: relative;
  padding: 0 ${theme.spacing(3)};
`;

const Index: NextPageWithLayout = () => {
  const isPC = useMediaQuery('(min-width:900px)');
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.location.hash === '#staff') {
        setTimeout(() => {
          window.location.href = '/luckybazaar/sponsor/#staff';
          // SPの場合は、スクロール位置を調整
          if (!isPC) {
            window.scrollBy(0, -40);
          }
        }, 500);
      }
    }
  }, []);

  return (
    <>
      <Head>
        <title>{constMeta.sponsor.title} </title>
        <meta name="description" content={constMeta.sponsor.mata_description} />
        <meta property="og:title" content={constMeta.sponsor.title} />
        <meta
          property="og:description"
          content={constMeta.sponsor.mata_description}
        />
        <meta
          property="og:image"
          content="https://iihi.life/assets/images/common/ogp.jpg"
        />
      </Head>
      <Container>
        <Box paddingTop={5} paddingBottom={6}>
          <Typography
            fontSize={28}
            fontWeight={700}
            paddingBottom={2}
            lineHeight={1.4}
            variant="h1"
          >
            当選品を募集しています
          </Typography>

          <Typography fontSize={15} paddingBottom={4} lineHeight={1.8}>
            キャンプは、その土地や一緒に行く人、その時のキャンプスタイルによって、まったく異なる表情を見せます。だから、行くたびに新しい発見があり、キャンプがもっと楽しくなる。
            <br />
            iihiは、そんなキャンプや自然の魅力を味わう人を増やしていきたいと考えています。
            <br />
            <br />
            ロトシーズは、キャンプに行きたい人の背中を後押しします。
            <br />
            キャンプ場のみなさん、メーカーなど企業のみなさんと一緒に、この魅力の輪を広げていけたらうれしく思います。ロトシーズの協賛というかたちでご一緒できることを、心待ちにしています！
            <br />
            <br />
            （※もちろんロトシーズ以外のご協力も随時受付中です。お気軽にお問い合わせください）
          </Typography>
          <Box>
            <Thumbnail
              image_height={72}
              max_height={360}
              sx={{ '& img': { objectFit: 'contain' } }}
            >
              <OptimizedImage
                src="/assets/images/luckybazaar/luckybazaar_1.png"
                width="100%"
                height="100%"
                alt="協賛品一例写真"
              />
            </Thumbnail>
          </Box>
          <Box paddingTop={5} id="staff">
            <Typography
              fontSize={21}
              fontWeight={700}
              paddingBottom={3}
              lineHeight={1.4}
              variant="h2"
            >
              キャンプ場の方へ
            </Typography>
            <Typography fontSize={15} paddingBottom={5} lineHeight={1.6}>
              キャンパーさんがキャンプにもっと行きたくなったり、キャンプライフを後押しする、オリジナルグッズやクーポン、薪などを提供いただけないでしょうか？
              <br />
              <br />
              ロトシーズの当選品として掲載されることで、iihiでの認知度向上や、訪問機会の創出につながることが期待できます。
              <br />
              なお、当選品のご提供以外に手数料等は一切いただきませんのでご安心ください！
              <br />
              <br />
              ロトシーズが、新規のキャンパーさんとの出会いや、常連キャンパーさんとの橋渡しになることを願って、iihiはロトシーズの企画に励んでまいります。
            </Typography>
          </Box>
          <Typography
            fontSize={21}
            fontWeight={700}
            paddingBottom={3}
            lineHeight={1.4}
            variant="h2"
          >
            企業の方へ
          </Typography>
          <Typography fontSize={15} paddingBottom={7} lineHeight={1.8}>
            お気に入りのギアを集めたり、自然のなかで料理をしたり。キャンプの楽しみやこだわりは、キャンプをすればするほど深まります。
            <br />
            <br />
            またキャンプやアウトドアは、キャンプ場はもちろん、ファッションや食卓、ベランダやリビングといった自宅など、あらゆる点でも味わえる側面があります。
            <br />
            <br />
            企業のみなさんとも、多面的にキャンプを味わう機会を後押しし、キャンプ・アウトドアシーンをより豊かにしていく企画をご一緒したり、当選品のご提供をいただけたらうれしいです。ぜひお気軽にご連絡ください。
          </Typography>
          <Stack center space={2}>
            <Link
              href={`/contact/company/?category=iihi提携キャンプ場・ロトシーズ協賛品について`}
            >
              <a>
                <Button
                  buttonSize="md"
                  sx={{ width: '289px', fontSize: '16px', fontWeight: 500 }}
                >
                  協賛のお問い合わせ
                </Button>
              </a>
            </Link>
          </Stack>
        </Box>
      </Container>
    </>
  );
};

Index.getLayout = (page) => <Layout>{page}</Layout>;

export default Index;
